export default "__VITE_ASSET__DJW7cVBy__"